<template>
  <div class="retention-message-create">
    <button
      type="button"
      class="btn btn-success"
      @click="openPicker"
      style="margin-left: 8px"
    >
      <i class="fas fa-plus"></i> Create Message
    </button>

    <retention-message-type-picker
      v-if="pickerOpen"
      @close="pickerOpen = false"
      @pick="onPick"
    />
  </div>
</template>

<script>
import RetentionMessageTypePicker from './MessageTypePicker.vue';

export default {
  name: 'RetentionMessageCreate',
  components: { RetentionMessageTypePicker },
  data() {
    return { pickerOpen: false };
  },
  computed: {
    activeApp() {
      return this.$store.getters.activeApp;
    }
  },
  methods: {
    openPicker() {
      this.pickerOpen = true;
    },
    onPick(type) {
      this.pickerOpen = false;
      this.$router.push({
        name: 'RetentionMessage',
        params: { aid: this.activeApp },
        query: { type }
      });
    }
  }
};
</script>

<style scoped>
.btn-success {
  padding: 7px 15px;
  font-weight: bold;
}
</style>
